import React from 'react';
import { FaShieldAlt, FaFileAlt, FaLock } from 'react-icons/fa';
import { Link } from 'react-scroll';
import { FiArrowRight } from 'react-icons/fi';
import Reveal from '../../fx/Reveal';
import Magnetic from '../../fx/Magnetic';

const features = [
    { icon: <FaShieldAlt />, title: 'Experienced Security Team', desc: 'Certified security professionals with years of operator-side experience.' },
    { icon: <FaFileAlt />, title: 'Comprehensive Reports', desc: 'Detailed findings with clear remediation steps and exec summaries.' },
    { icon: <FaLock />, title: 'Confidentiality Assured', desc: 'All engagements are conducted with the highest level of confidentiality.' },
];

const SecureOrgSection = () => {
    return (
        <section className="relative bg-[#05060a] text-white px-6 md:px-16 py-24 overflow-hidden">
            <div className="absolute -left-32 top-10 w-[500px] h-[500px] rounded-full bg-red-700/10 blur-3xl pointer-events-none" />
            <div className="relative max-w-7xl mx-auto">
                <Reveal>
                    <div className="card p-8 md:p-12 grid md:grid-cols-2 gap-10 items-center">
                        <div>
                            <span className="pill tag inline-flex mb-4">READY?</span>
                            <h2 className="font-display text-3xl md:text-4xl font-bold mb-4 leading-tight">
                                Ready to <span className="text-gradient-red">secure</span> your organization?
                            </h2>
                            <p className="text-gray-400 mb-7 leading-relaxed">
                                Our team is ready to help you identify and address vulnerabilities
                                before they can be exploited.
                            </p>
                            <Link to="contact" smooth duration={600} offset={-40} className="cta-item">
                                <Magnetic>
                                    <span className="btn-primary cursor-pointer">Schedule a consultation <FiArrowRight /></span>
                                </Magnetic>
                            </Link>
                        </div>
                        <div className="space-y-5">
                            {features.map((f, i) => (
                                <div key={i} className="flex items-start gap-4">
                                    <div className="w-11 h-11 rounded-xl bg-red-500/10 border border-red-500/30 flex items-center justify-center text-red-400 flex-shrink-0">
                                        {f.icon}
                                    </div>
                                    <div>
                                        <h4 className="font-semibold mb-1">{f.title}</h4>
                                        <p className="text-gray-400 text-sm leading-relaxed">{f.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};

export default SecureOrgSection;
